import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextInput from 'Components/forms/text-input/TextInput.jsx';
import TextField from 'Components/forms/text-field/TextField.jsx';
import TextareaInput from 'Components/forms/textarea-input/TextareaInput.jsx';
import ResponseBanner from 'Components/cards/ResponseBanner';
import PrimaryButton from 'Components/Button/PrimaryButton';
import Button from 'Components/Button/Button';
import 'react-datepicker/dist/react-datepicker.css';
import './FormGroupControl.scss';
import SingleDateInput from 'Components/forms/SingleDateInput/SingleDateInput';
import SelectInput from 'Components/forms/select-input/SelectInput.jsx';
import Label from 'Components/forms/label/Label';
import moment from 'moment';
import counterpart from 'counterpart';
import ImagePortal from 'Containers/ImagePortal';
import { COLORS } from "Constants/BIDashboardConstants.js"

let missingField;
let titleValue;
let bannerTitle;
export class FormGroupControl extends Component {
  constructor(props) {
    super(props);
    let mandatoryFields = [];
    this.props.columns.forEach((column) => {
      if (column.isRequired) {
        if (column.columnKey === 'paymentCurrencyAlpha') {
          if (this.props.dropDownMandatoryField) {
            mandatoryFields.push(column);
          }
        } else {
          mandatoryFields.push(column);
        }
      }
    });
    this.state = {
      isValidForm: true,
      isButtonDisabled: true,
      mandatoryFields,
      formErrors: {},
      formFieldColumns: this.props.columns,
    };
    this.attachBindings();
  }

  componentWillMount() {
    this.setDefaultState();
  }

  componentDidUpdate(prevProps) {
    if(this.props.columns && prevProps.columns && this.props.columns[0]?.list?.length !== prevProps.columns[0]?.list?.length) {
      this.setState({
        formFieldColumns : this.props.columns
      });
    }
  }

  attachBindings() {
    this.handleOnChange = this.handleOnChange.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.showBanner = this.showBanner.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.setDefaultState = this.setDefaultState.bind(this);
    this.handleSingleDateChange = this.handleSingleDateChange.bind(this);
    this.handleManualAddTransaction = this.handleManualAddTransaction.bind(this);
    this.validateInputField = this.validateInputField.bind(this);
  }

  // This method is used for closing the banner.
  closeBanner() {
    this.setState({
      isValidForm: true,
    });
  }

  // This method is used for setting default values in state
  setDefaultState() {
    this.setState(this.props.setDefaultValues);
  }

  // This method is used for validation of form
  validateForm(state) {
    let validForm = true;
    this.state?.formFieldColumns?.map((column) => {
      if (column?.errorMsg) {
        validForm = false;
        document.getElementById(column?.columnKey).focus();
        this.setState({
          isValidForm: false,
        });
        titleValue = column?.title;
        missingField = 'Please provide input for : ';
        bannerTitle = 'Parameter is missing!';
      }
    });
    if (validForm) {
      delete this.state.isValidForm;
      this.props.onClickPrimaryActionButton(state);
    }
  }

  // This method is used for showing banner on UI.
  showBanner() {
    if (!this.state.isValidForm && this.state.isValidForm !== undefined) {
      return (
        <div>
          <ImagePortal>
          <ResponseBanner
            titleStyle={{ color: 'light-green' }}
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title={bannerTitle}
            description={missingField}
            type="warning"
            onClose={this.closeBanner}
            cancelOnly
            cancelButtonText={counterpart('globalTranslate.takeAction.dismiss')}
            primaryButtonActionValue={titleValue}
          />
          </ImagePortal>
        </div>
      );
    }
  }

  // This method is used for validate input field on change.
  validateInputField(event) {
    let fieldError = '';
    this.state.formFieldColumns.forEach((column) => {
      if (column?.columnKey === event?.target?.name) {
        if (column?.isRequired && event?.target?.value === '') {
          fieldError = 'This field is required.';
        } else if (event?.target?.value && column?.validate) {
          const errMsg = column.validate(event?.target?.value);
          if (errMsg) {
            fieldError = errMsg;
          }
          else if(column.min && event?.target?.value.length !== 0 && event?.target?.value.length !== column.min) {
            fieldError = `The minimum length required for this field is ${column.min} characters.`;
          }
        }
      }
    });
    return fieldError;
  }

  // This method is used for updating the forms.
  handleOnChange(event) {
    if (event?.target) {
      const formErrors = { ...this.state.formErrors };
      const fieldError = this.validateInputField(event);
      const updatedFormFieldColumns = this.state?.formFieldColumns?.map((column) => {
        if (column.columnKey === event.target.name) {
          column.errorMsg = fieldError;
        }
        return column;
      });
      if (fieldError) {
        formErrors[event.target.name] = fieldError;
      } else {
        delete formErrors[event.target.name];
      }
      this.setState(
        {
          [event.target.name]: event.target.value,
          formErrors: { ...formErrors },
          formFieldColumns: updatedFormFieldColumns,
        },
        this.handleManualAddTransaction,
      );
    } else {
      console.error('Invalid event occured', event);
    }
  }

  handleManualAddTransaction = () => {
    let allMandatoryEntries = true;
    const isErrorExist = !!Object.keys(this.state.formErrors).length;
    this.state.mandatoryFields.forEach(({ inputType, columnKey }) => {
      if (
        (inputType === 'Date' && Number.isNaN(this?.state[columnKey]?._i)) ||
        !(this.state[columnKey] && this.state[columnKey] !== '' && !isErrorExist)
      ) {
        allMandatoryEntries = false;
      }
    });
    this.setState({ isButtonDisabled: !allMandatoryEntries });
  };

  handleSingleDateChange = (id, value) => {
    this.setState(
      {
        [id]: value,
      },
      this.handleManualAddTransaction,
    );
  };

  onSelectionChange = (option) => {
    var selectedOption;
    var id;
    for (let i = 0; i < this.state.formFieldColumns.length; i++) {
      if (this.state.formFieldColumns[i].inputType == 'DropDown') {
        selectedOption =
          option.value == undefined
            ? this.state.formFieldColumns[i].list.find((item) => item.value === option)
            : this.state.formFieldColumns[i].list.find((item) => item.value === option.value);
        if (selectedOption) {
          id = this.state.formFieldColumns[i].columnKey;
          break;
        }
      }
    }
    this.setState({
      [id]: selectedOption,
    },
      this.handleManualAddTransaction,
    );
  };

  getForm(column) {
    switch (column.inputType) {
      case 'TextArea':
        return (
          <TextField htmlFor={column.columnKey} labelContent={column.title} isRequired={column.isRequired}>
            <TextareaInput
              name={column.columnKey}
              label={column.title}
              type={column.inputType}
              onChange={this.handleOnChange}
              id={column.columnKey}
              placeholder={column.title}
              value={this.state[column.columnKey]}
            />
          </TextField>
        );
      case 'DropDown':
        return (
          <TextField
            fieldClass="field--fixed-width"
            htmlFor={column.title}
            labelContent={
              <span data-radium>
                <Label
                  extraStyle={{ fontSize: 12, fontWeight: 500, color: COLORS.oneGp.black }}
                  htmlFor="user-permissions-list"
                  labelClass="field-label checkbox-group-parent-label"
                >
                  {column.title} 
                  {this.props.dropDownMandatoryField && column.isRequired && (
                    <span className="field_required" style={{ color: '#f4364c' }}>
                      *
                    </span>
                  )}
                </Label>
              </span>
            }
            width={column.inputBoxWidth}
          >
            <div style={{ marginBottom: '16px' }} id={column.columnKey}>
              <SelectInput
                selectClass={{ zIndex: 15 }}
                dataList={column.list}
                promptText={'- Select -'}
                wrapperClass="select-menu__form reports"
                extraClass="option-box"
                elementStyle={{
                  width: column.inputBoxWidth,
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                }}
                handleSelection={this.onSelectionChange}
                selectedItem={this.state[column.columnKey]}
              />
            </div>
          </TextField>
        );
      case 'Date':
        let singleDateFormat =
          this.state[column.columnKey] && Number.isNaN(this.state[column.columnKey]._i)
            ? ''
            : this.state[column.columnKey];
        return (
          <div style={{ width: column.inputBoxWidth }} id={column.columnKey}>
            <SingleDateInput
              id={column.columnKey}
              name={column.columnKey}
              singleDate={singleDateFormat}
              onApply={this.handleSingleDateChange}
              title={column.title}
              minDate={moment().subtract(10, 'years')}
              dateFormat={column.dateFormat}
              isRequired={column.isRequired}
            />
          </div>
        );

      default:
        return (
          <TextInput
            width={column.inputBoxWidth}
            name={column.columnKey}
            id={column.columnKey}
            label={column.title}
            type={column.inputType}
            min={column.min}
            max={column.max}
            error={column.errorMsg || ''}
            onChange={this.handleOnChange}
            placeholder={column.description}
            value={this.state[column.columnKey]}
            isRequired={column.isRequired}
            disable={column.disabled ? column.disabled : false}
            extraStyle={{ fontSize: 12, fontWeight: 500, color: COLORS.oneGp.black }}
          />
        );
    }
  }

  getButtons() {
    let buttonStyle = this.props.buttonStyle;
    let cancelButtonStyle = this.props.cancelButtonStyle;
    let formWrapperStyle = this.props.formWrapperStyle;
    return (
      <div className="button-wrapper" style={formWrapperStyle}>
        <Button
          category="link-inline"
          style={cancelButtonStyle}
          extraClass="clear"
          action={this.props.onClickCancelButton}
          url=""
        >
          Cancel
        </Button>
        <PrimaryButton
          style={buttonStyle}
          action={this.validateForm}
          url={this.state}
          disabled={this.state.isButtonDisabled}
        >
          {this.props.primaryActionButtonText}
        </PrimaryButton>
      </div>
    );
  }
  render() {
    const formControlGroup = this.state.formFieldColumns.map((column) => {
      return (
        <div key={column.columnKey}>
          <div className="verticalFormField" style={{ padding: 8 }}>
            {this.getForm(column)}
          </div>
        </div>
      );
    });

    return (
      <div>
        {' '}
        {this.showBanner()}
        <div
          className="floatRightFormGroupControl"
          style={this.props.formGroupExtraStyle ? this.props.formGroupExtraStyle : {}}
        >
          {this.props.formTitle && (
            <div style={{ paddingBottom: '7px', paddingLeft: '24px' }}>
              <h1>
                <b>{this.props.formTitle}</b>
              </h1>
            </div>
          )}
          <div
            className="formWrapper"
            style={{
              width: this.props.formWidth,
              marginBottom: this.props.formMarginBottom ? this.props.formMarginBottom : undefined,
            }}
          >
            <div className="detailViewItems">{formControlGroup}</div>
            {this.getButtons()}
          </div>
        </div>
      </div>
    );
  }
}
FormGroupControl.propTypes = {
  columns: PropTypes.array,
  setDefaultValues: PropTypes.func,
  formWidth: PropTypes.string,
  formMarginBottom: PropTypes.string,
  formGroupExtraStyle: PropTypes.object,
  formTitle: PropTypes.string,
  onClickCancelButton: PropTypes.func,
  formWrapperStyle: PropTypes.object,
  cancelButtonStyle: PropTypes.object,
  buttonStyle: PropTypes.object,
  primaryActionButtonText: PropTypes.string,
  onClickPrimaryActionButton: PropTypes.func,
  dropDownMandatoryField: PropTypes.bool,
};

FormGroupControl.defaultProps = {
  buttonStyle: { marginLeft: 10 },
  cancelButtonStyle: {},
  formWrapperStyle: {},
};

export default FormGroupControl;
